(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ng-trust-contact"] && !Shopify.designMode) return;
  try {
    (() => {
    const seen = new WeakSet();
    function identify() {
      const whatsapp = document.querySelector('.ng-whatsapp');
      const whatsappLabel = whatsapp?.querySelector('span');
      if (whatsappLabel && whatsappLabel.textContent !== 'WhatsApp') whatsappLabel.textContent = 'WhatsApp';
      const chat = document.querySelector('shopify-chat');
      const root = chat?.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot;
      if (!root) return false;
      const label = root.querySelector('.activator__label');
      if (label && label.textContent !== 'Asistente virtual') label.textContent = 'Asistente virtual';
      const button = root.querySelector('button[part="activator"]');
      if (button) {
        const title = button.getAttribute('aria-expanded') === 'true' ? 'Asistente virtual. Cerrar chat' : 'Asistente virtual. Abrir chat';
        if (button.getAttribute('aria-label') !== title) button.setAttribute('aria-label', title);
      }
      if (!seen.has(root)) {
        seen.add(root);
        new MutationObserver(identify).observe(root, {subtree:true, childList:true, attributes:true, attributeFilter:['aria-expanded']});
      }
      return Boolean(label && whatsappLabel);
    }
    let attempts = 0;
    const timer = setInterval(() => { if (identify() || ++attempts >= 80) clearInterval(timer); }, 250);
    identify();
  })();
  } catch(e) { console.error(e); }
})();

})();
